import { useState, useCallback } from 'react';
import { useInView } from 'react-hook-inview';
import { Options } from 'react-hook-inview/dist/useInView';

export type UseRefInViewOptions = Options;

export interface UseRefInViewResult {
  current: HTMLElement | null,
  ref: (node: Element) => void,
  isVisible: boolean,
  entry: IntersectionObserverEntry,
}

export default function useRefInView(options: UseRefInViewOptions = {}): UseRefInViewResult {
  const [current, setCurrent] = useState(null);
  const [ref, isVisible, entry] = useInView(options);

  const refCallback = useCallback((node: Element) => {
    setCurrent(node);
    ref(node);
  }, [ref]);

  return {
    current,
    ref: refCallback,
    isVisible,
    entry,
  };
}
